//抽奖PC WAP公用数据
import { ck, $subscriber } from "fire-wind-water";
import ws from "../services/webinar";

export function buildQuestionData(data) {
  return Object.assign(
    {
      src: "",
      isShow: false,
      webinarInfo: {},
      randomNum: 10
    },
    data
  );
}

export function buildQuestionMethod(otherMethods) {
  return Object.assign(
    {
      getQuestion(id, type) {
        let self = this;
        var random = Math.ceil(Math.random() * self.randomNum) * 1000;
        if (type && type == "shoudong") {
          let param = {
            globalUserId: ck.cookie("globalUserId"),
            questionaryId: id
          };
          let cookie = ck.cookie("smarketMember_" + self.webinarInfo.schemaId);
          if (cookie != "" && cookie != null) {
            param.sess = cookie.session;
          }
          ws.hasParticipation(param).subscribe(data => {
            if (data.content.hasJoin.toString() === "0") {
              let param = {
                questionnaireId: id,
                tenantId: self.webinarInfo.tenantId,
                __module__: 2,
                __objId__: self.webinarInfo.webinarId
              };
              ws.getQuestionnaire(param).subscribe(res => {
                let addQueryParams =
                  "&tenantId=" +
                  self.webinarInfo.tenantId +
                  "&moduleId=2" +
                  "&objId=" +
                  self.webinarInfo.webinarId +
                  "&withoutwx=1";
                if (res.content.shortUrl[self.type].longUrl.indexOf("#") > -1) {
                  addQueryParams = "&withoutwx=1";
                }
                window.$sk
                  .goto(
                    res.content.shortUrl[self.type].longUrl + addQueryParams,
                    true
                  )
                  .subscribe(data => {
                    self.src = data;
                  });
                self.isShow = true;
              });
            } else {
              let param1 = {
                questionnaireId: id,
                tenantId: self.webinarInfo.tenantId,
                __module__: 2,
                __objId__: self.webinarInfo.webinarId
              };
              ws.getQuestionnaire(param1).subscribe(res => {
                let addQueryParams =
                  "&tenantId=" +
                  self.webinarInfo.tenantId +
                  "&moduleId=2" +
                  "&objId=" +
                  self.webinarInfo.webinarId +
                  "&withoutwx=1";
                if (res.content.shortUrl[self.type].longUrl.indexOf("#") > -1) {
                  addQueryParams = "&withoutwx=1";
                }
                window.$sk
                  .goto(
                    res.content.shortUrl[self.type].longUrl + addQueryParams,
                    true
                  )
                  .subscribe(data => {
                    self.src = data;
                  });
                self.isShow = true;
              });
            }
          });
        } else {
          setTimeout(function() {
            let param = {
              globalUserId: ck.cookie("globalUserId"),
              questionaryId: id
            };
            let cookie = ck.cookie(
              "smarketMember_" + self.webinarInfo.schemaId
            );
            if (cookie != "" && cookie != null) {
              param.sess = cookie.session;
            }

            ws.hasParticipation(param).subscribe(data => {
              if (data.content.hasJoin.toString() === "0") {
                let param2 = {
                  questionnaireId: id,
                  tenantId: self.webinarInfo.tenantId,
                  __module__: 2,
                  __objId__: self.webinarInfo.webinarId
                };
                ws.getQuestionnaire(param2).subscribe(res => {
                  let addQueryParams =
                    "&tenantId=" +
                    self.webinarInfo.tenantId +
                    "&moduleId=2" +
                    "&objId=" +
                    self.webinarInfo.webinarId +
                    "&withoutwx=1";
                  if (
                    res.content.shortUrl[self.type].longUrl.indexOf("#") > -1
                  ) {
                    addQueryParams = "&withoutwx=1";
                  }
                  window.$sk
                    .goto(
                      res.content.shortUrl[self.type].longUrl + addQueryParams,
                      true
                    )
                    .subscribe(data => {
                      console.log("问卷 iframe 地址是", data);
                      self.src = data;
                      console.log("新的 问卷 iframe 地址是", self.src);
                    });
                  self.isShow = true;
                });
              }
            });
          }, random);
        }
      },
      close() {
        this.isShow = false;
      }
    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;

  $subscriber.subscribe("onPublishQuestionnaire", data => {
    self.getQuestion(data[0].id);
  });
  $subscriber.subscribe("onUserOnlineNum", data => {
    self.randomNum = data.questionnaireDelay.time;
  });
  $subscriber.subscribe("onQuestionnaire", data => {
    if (data.length > 0) {
      self.getQuestion(data[0].id);
    }
  });
  $subscriber.subscribe("webinarInfo", data => {
    self.webinarInfo = data;
  });
  $subscriber.subscribe("showQuestion", data => {
    if (data == "shoudong") {
      if (self.webinarInfo.questionaryId) {
        self.getQuestion(self.webinarInfo.questionaryId, "shoudong");
      } else {
        $subscriber.emit("showPopup", { message: "主办方暂时没有设置问卷！" });
      }
    } else {
      if (self.webinarInfo.questionaryId) {
        self.getQuestion(self.webinarInfo.questionaryId);
      } else {
        $subscriber.emit("showPopup", { message: "主办方暂时没有设置问卷！" });
      }
    }
  });
  $subscriber.subscribe("onCloseQuestionnaire", () => {
    self.close();
  });
}
